import { Navigate } from 'react-router-dom';
import useAuthStore from '../stores/authStore';
import { UserRole } from '../types/auth';

interface ProtectedRouteProps {
	children: React.ReactNode;
	allowedRoles?: UserRole[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
	const { isAuthenticated, user } = useAuthStore();

	if (!isAuthenticated || !user) {
		return <Navigate to="/login" replace />;
	}

	if (allowedRoles && !allowedRoles.includes(user.role)) {
		return <Navigate to="/dashboard" replace />;
	}

	return <>{children}</>;
};

export default ProtectedRoute;
